import { render, staticRenderFns } from "./pis.vue?vue&type=template&id=a1ec30dc&"
import script from "./pis.vue?vue&type=script&lang=js&"
export * from "./pis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports